import classNames from 'classnames';
import React from 'react';

const PanelBody = (props) => {
  return (
    <div className={ classNames('panel__body', props.className) }>
      { props.children }
    </div>
  );
};

export default PanelBody;



// WEBPACK FOOTER //
// ./app/components/shared/panel/_PanelBody.jsx